import React from 'react'

import { LoadingPlaceholder } from '@sketch/components'
import { ReactComponent as DocumentIcon } from '@sketch/icons/document-17'
import { thumbnailForPreviewFile } from '@sketch/modules-common'
import { isTruthy } from '@sketch/utils'

import { FolderArchivedNotificationDetailsFragment } from '@sketch/gql-types'

import {
  SubjectFolderGrid,
  SubjectFolderIcon,
  SubjectFolderImage,
  SubjectFolderTile,
} from './InboxListItemPreview.styles'

interface FolderPreviewProps {
  folder: FolderArchivedNotificationDetailsFragment['folder']
}

const EMPTY_FOLDER_TILE_COUNT = 4

export const FolderPreview = ({ folder }: FolderPreviewProps) => {
  const previews = folder?.previews.slice(0, 4) ?? []

  if (previews.length === 0) {
    return (
      <SubjectFolderGrid aria-label={folder?.name ?? 'Folder'}>
        {Array.from({ length: EMPTY_FOLDER_TILE_COUNT }).map((_, index) => (
          <SubjectFolderTile key={index} />
        ))}
      </SubjectFolderGrid>
    )
  }

  return (
    <SubjectFolderGrid aria-label={`Folder ${folder?.name ?? ''}`}>
      {previews.map(({ name, file }, index) => {
        const thumbnails = (file?.thumbnails || []).filter(isTruthy)

        return (
          <SubjectFolderTile key={index}>
            {thumbnails.length === 0 ? (
              <SubjectFolderIcon>
                <DocumentIcon aria-label="No Image available" />
              </SubjectFolderIcon>
            ) : (
              <SubjectFolderImage
                src={thumbnailForPreviewFile(file)}
                alt={name}
                loadingPlaceholder={<LoadingPlaceholder />}
              />
            )}
          </SubjectFolderTile>
        )
      })}
    </SubjectFolderGrid>
  )
}
